import { GenericFailure } from '@playq/services-shared';

// https://tanstack.com/query/latest/docs/framework/react/guides/migrating-to-react-query-4#undefined-is-an-illegal-cache-value-for-successful-queries
export const createRequestQueue = <PayloadType, ResultType = null>(
  handler: (items: PayloadType[]) => Promise<(ResultType | null)[]> | void,
  options?: {
    predicate?: (data: PayloadType, result: ResultType | null) => boolean;
    timeout?: number;
  }
) => {
  let timerId: number | undefined;
  let items: {
    data: PayloadType;
    resolve: (data: ResultType | null) => void;
    reject: (err: GenericFailure) => void;
  }[] = [];

  return {
    push: (payload: PayloadType) => {
      return new Promise<ResultType | null>((resolve, reject) => {
        window.clearTimeout(timerId);
        items.push({ data: payload, resolve, reject });
        timerId = window.setTimeout(() => {
          const data = [...items];
          items = [];
          const res = handler(data.map((item) => item.data));
          if (res && options?.predicate !== undefined) {
            res
              .then((result) => {
                data.forEach((item) => {
                  const resultItem = result.find((r) => options?.predicate?.(item.data, r));
                  item.resolve(resultItem ?? null);
                });
              })
              .catch((e) => data.forEach((item) => item.reject(e)));
          }
        }, options?.timeout ?? 100);
      });
    },
  };
};
